// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorPopover-cls1_kjq","cls2":"AuthorPopover-cls2_1kI AuthorPopover-cls1_kjq"};